/** El resumen que devuelve `GET /payments/needing-attention`. */
export interface ResumenPorAtender {
	remanentes?: number
	anulados?: number
	posiblesDuplicados?: number
}

/**
 * Cuántos pagos están **de verdad pendientes**. Una sola definición, dos consumidores.
 *
 * **La regla es que el aviso cuente exactamente lo que se va a encontrar dentro.** Cualquier otra
 * cosa —por bien razonada que esté— destruye la confianza en el aviso, que es lo único que hace que
 * alguien vaya a mirar. La bandeja enseña tres grupos; dos son trabajo y uno es historia.
 *
 * Los **posibles duplicados SÍ cuentan**. Se excluyeron un rato con el argumento de que son un
 * subconjunto de los pagos con saldo y se contarían dos veces: es falso en la práctica. Un duplicado
 * conserva su saldo, así que **no** cae en remanentes — aparece solo en su grupo. Con el aviso en 1
 * y dos filas dentro, el número era simplemente menor que la realidad.
 *
 * Los **anulados** no cuentan: ya se atendieron, y esa lista existe como camino de vuelta —para
 * deshacer—, no como trabajo. Sumarlos haría que el aviso nunca bajara a cero.
 */
export function pagosPorAtender(resumen: ResumenPorAtender | null | undefined): number {
	if (!resumen) return 0

	return (resumen.remanentes || 0) + (resumen.posiblesDuplicados || 0)
}
